import {Component, EventEmitter, Input, Output} from '@angular/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import {FormsModule} from '@angular/forms';
import {MatIconModule} from '@angular/material/icon';
import {TimeRangeSelector} from '../../time-range-selector/time-range-selector';

@Component({
  selector: 'chart-header',
  standalone: true,
  templateUrl: './chart-header.html',
  styleUrl: './chart-header.scss',
  imports: [
    CommonModule,
    MatButtonToggleModule,
    MatDialogModule,
    FormsModule,
    MatIconModule,
    TimeRangeSelector,
  ],
})
export class ChartHeader {

  @Input() totalConsumption: number | null = null;

  @Output() timeRangeChange = new EventEmitter<{ start: Date; end: Date }>();
  @Output() exportCsv = new EventEmitter<void>();

  onTimeRangeChanged(event: { start: Date; end: Date }) {
    console.log("On time change event - chart header")
    this.timeRangeChange.emit(event);
  }

  formatConsumption(value: number): string {
    return (Math.round((value + Number.EPSILON) * 10) / 10).toFixed(1).replace('.', ',');
  }
}
